export default __webpack_public_path__ + "static/media/property_837.52b55dac.png";